import _ from 'lodash';
import React, { FunctionComponent } from 'react';
import ViewCard, { ViewCardProps } from './ViewCard';
import { I18n } from 'common/i18n';

const ExternalViewCard: FunctionComponent<ViewCardProps> = function(props) {
  const linkProps = _.defaults({}, props.linkProps, {
    target: '_blank',
    rel: 'nofollow external'
  });

  return (
    <ViewCard
      // `...props` spread below will overwrite this?
      // @ts-expect-error TS(2783) FIXME: 'icon' is specified more than once, so this usage ... Remove this comment to see the full error message
      icon="socrata-icon-external-square"
      // `...props` spread below will overwrite this?
      // @ts-expect-error TS(2783) FIXME: 'metadataLeft' is specified more than once, so thi... Remove this comment to see the full error message
      metadataLeft={I18n.t('shared.components.view_card.external_content')}
      {...props}
      linkProps={linkProps}>
      {props.children}
    </ViewCard>
  );
};

export default ExternalViewCard;
